import React from "react";
import { Chip } from "@mui/material";
function FilterChip({ label = "" }) {
  // Returns a chip to be used in the datagrids
  return (
    <span
      style={{
        backgroundColor: "#42a5f5",
        color: "whitesmoke",
        borderRadius: "20px",
        padding: "5px 10px 5px 10px",
        fontSize: "13px",
      }}
      
    >
      {label.split(":").map((e, i) =>
        i === 0 && label.split(":").length > 1 ? (
          <span key={i} style={{ color: "#fff" }}>
            {e + " "}
          </span>
        ) : (
          <Chip
            key={i}
            label={e}
            size="small"
            sx={{
              "& .css-wjsjww-MuiChip-label": {
                overflow: "hidden",
                textOverflow: "unset",
                paddingRight: '12px'
              },
              "& .css-1pjtbja": {
                overflow: "hidden",
                textOverflow: "unset",
                paddingRight: '12px'
              },
              color: "#141f91",
              backgroundColor: "#fff",
              marginRight: "-5px",
              fontSize: "12px",
            }}
          />
          // <span>{e}</span>
        )
      )}
    </span>
  );
}

export default FilterChip;